import { string, table } from "@rocicorp/zero";

export const projectMember = table("projectMembers")
	.from("project_members")
	.columns({
		id: string(),
		orgId: string().from("org_id"),
		projectId: string().from("project_id"),
		userId: string().from("user_id"),
		role: string(),
	})
	.primaryKey("id");
